/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
declare const ActiveXObject: any;

export default class XML {
    static getNodeText(node: any) {
        if (document.all) {
            return node.data;
        } else {
            return node.wholeText;
        }
    }

    static getValueOfChildByTag(parentNode: Element, tagName: string, nullValue?: any) {
        try {
            /* null check override: errors handled with try/catch */
            return parentNode.querySelector(tagName)!.firstChild!.nodeValue;
        } catch (e) {
            /* ignore */
        }
        return typeof nullValue === 'undefined' ? null : nullValue;
    }

    static getAttribute(node: Element | null, attr: string, defaultValue: string = ''): string {
        if (node) {
            const value = node.getAttribute(attr);
            if (value !== null) {
                return value;
            }
        }
        return defaultValue;
    }

    static getAttributeInt(node: Element | null, attr: string, defaultValue: number = 0): number {
        if (node) {
            /* null check override: parseInt correctly handles null */
            const ret = parseInt(node.getAttribute(attr)!, 10);
            return isNaN(ret) ? defaultValue : ret;
        }
        return defaultValue;
    }

    static parse(src: string): Document | null {
        if (typeof (window as any).DOMParser !== 'undefined') {
            const parser = new DOMParser();
            return parser.parseFromString(src, 'text/xml');
        } else {
            const xmlDoc: any = new ActiveXObject('Microsoft.XMLDOM');
            xmlDoc.async = false;
            xmlDoc.loadXML(src);
            if (xmlDoc.documentElement) {
                return xmlDoc;
            }
        }
        return null;
    }

    static responseXML(xhr: XMLHttpRequest): Document {
        /* specifics of file:// protocol in IE */
        const isLocal = xhr.status === 0;
        let xml = null;

        if (xhr.readyState === 4 && (xhr.status === 200 || isLocal)) {
            if (xhr.responseXML && (xhr.responseXML.documentElement || !isLocal)) {
                xml = xhr.responseXML;
            } else {
                xml = XML.parse(xhr.responseText);
            }
        }
        if (!xml) {
            throw new Error('Failed to read response XML');
        }
        return xml;
    }
}
